import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import { GlassCard } from './glass-card';
import { AnimatedCounter } from './animated-counter';
import { cn } from '@/lib/utils';

interface MetricCardProps {
  title: string;
  value: number | string | undefined | null;
  icon: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color: string;
  bgColor: string;
  prefix?: string;
  suffix?: string;
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  trend,
  color,
  bgColor,
  prefix = '',
  suffix = '',
  className
}) => {
  console.log(`MetricCard ${title} - value:`, value, typeof value);
  return (
    <GlassCard className={cn('p-6', className)} hover>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
            {title}
          </p>
          <div className="flex items-baseline gap-2">
            <AnimatedCounter
              value={value}
              prefix={prefix}
              suffix={suffix}
              className="text-3xl font-bold text-gray-900 dark:text-white"
              duration={2.5}
            />

            {trend && (
              <motion.div
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 1, duration: 0.5 }}
                className={cn(
                  'flex items-center text-xs font-medium px-2 py-1 rounded-full',
                  trend.isPositive
                    ? 'text-green-700 bg-green-100 dark:text-green-400 dark:bg-green-900/30'
                    : 'text-red-700 bg-red-100 dark:text-red-400 dark:bg-red-900/30'
                )}
              >
                <span className="mr-1">
                  {trend.isPositive ? '↗' : '↘'}
                </span>
                {Math.abs(trend.value)}%
              </motion.div>
            )}
          </div>
        </div>

        <motion.div
          className={cn(
            'p-4 rounded-2xl shadow-lg',
            color
          )}
          whileHover={{ scale: 1.1, rotate: 5 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.2 }}
        >
          <Icon className="h-6 w-6 text-white" />
        </motion.div>
      </div>

      {/* Background decoration */}
      <div className={cn(
        'absolute -top-2 -right-2 w-20 h-20 rounded-full opacity-10',
        bgColor
      )} />
    </GlassCard>
  );
};